import styled, { css } from 'styled-components';
import { Label } from '../Label/Label.styled';
import {
  RadioTabCheckedStyledProps,
  RadioTabStyledProps,
} from './RadioTab.types';

const getOptionDisabledStyles = () => css`
  cursor: not-allowed;
  border-color: transparent;
  color: #999999;
`;

const getOptionCheckedStyles = () => css`
  color: #333333;
  border: 2px solid #333333;
  border-radius: 4px;
  box-shadow: 0px 1px 4px rgba(51, 51, 51, 0.24);
  cursor: default;
  font-weight: 700;
`;

const getOptionErrorStyles = () => css`
  color: #cc2324;
`;

const getDisabledStyles = () => css`
  background: #f2f2f2;
`;

const getErrorStyles = () => css`
  border-color: #cc2324;
`;

const Radio = styled.input`
  appearance: none;
  opacity: 0;
  position: absolute;

  &:focus {
    opacity: 1;
    outline-color: ${({ theme }) => theme.brand.primary.base};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

const RadioTabChecked = styled.div<RadioTabCheckedStyledProps>((props) => {
  const { total, index, disabled } = props;

  return css`
    position: absolute;
    top: -1px;
    bottom: -1px;
    left: ${`calc(-1px + ${index}/${total} * 100%)`};
    width: ${`calc(1/${total} * 100% + 2px)`};
    border-radius: 4px;
    border: 2px solid #333333;
    box-shadow: 0px 1px 4px rgba(51, 51, 51, 0.24);
    transition: left 200ms ease-in-out;

    ${disabled &&
    css`
      border-color: #999999;
      pointer-events: none;
    `}
  `;
});

const RadioTabOption = styled.div<{
  hasError: boolean;
  disabled: boolean;
  checked: boolean;
}>((props) => {
  const { hasError, disabled, checked } = props;

  return css`
    ${Label} {
      padding: 8px 16px;
      transition: left 200ms ease-in-out 0s;
      cursor: pointer;
      color: #666666;
      border-color: #666666;
      font-weight: 400;
      ${checked && getOptionCheckedStyles}
      ${disabled && getOptionDisabledStyles}
      ${hasError && getOptionErrorStyles}
    }
  `;
});

const RadioTab = styled.div<RadioTabStyledProps>((props) => {
  const { hasError, disabled } = props;

  return css`
    position: relative;
    height: 40px;
    line-height: 40px;
    display: inline-flex;
    background: rgb(255, 255, 255);
    border-radius: 4px;
    border: 1px solid rgb(153, 153, 153);
    margin-bottom: 4px;
    width: 100%;

    ${RadioTabOption} {
      position: relative;
      flex-basis: 0px;
      display: flex;
      flex-grow: 1;
      align-items: center;
      justify-content: center;

      border-left: 1px solid rgb(153, 153, 153);

      ${hasError && getErrorStyles()}
      &:first-child {
        border-left: 0;
        border-radius: 4px 0 0 4px;
      }

      &:last-child {
        border-radius: 0 4px 4px 0;
      }

      ${Label} {
        width: 100%;
        text-align: center;
        border: none;
        box-shadow: none;
      }
    }

    ${hasError && !disabled && getErrorStyles()}
    ${disabled && !hasError && getDisabledStyles()}
  `;
});

export { Radio, RadioTabOption, RadioTab, RadioTabChecked };
